<template>
	<div class="measurementTracker">
		<AppHeader></AppHeader>
		<div class="page-wrapper">
			<div class="container-fluid" v-if="!paymentConfirmed">
                                Confirming payment...
			</div>
                        <div class="container-fluid" v-if="!paymentConfirmed">
                                <div class="text-center">
                                        <img src="/dist/img/icons/checked.png" alt="" style="height:86px">
                                        <h3>Thank you for your Purchase!</h3>
                                        <h5>Your account has been upgraded to VIP!</h5>
                                </div>                                
			</div>
			<!-- /Main Content -->
			<AppFooter></AppFooter>
		</div>
	</div>
</template>

<script>

import API from '../../services/api.js';
import AppHeader from '../../components/common/AppHeader.vue'
import AppFooter from '../../components/common/AppFooter.vue'
import Datepicker from 'vuejs-datepicker'
import swal from 'sweetalert'

import {
	mapMutations
} from 'vuex';
const api = new API();

export default {
	data() {
		return {
                        me: this.$store.getters.user,
                        paymentConfirmed:false
		}
        },
        components:{
                AppHeader,
		AppFooter,
		swal
        },
	created() {
                this.confirmPayment();
	},
	methods: {
                confirmPayment(){
                        api.confirmPayment(this.$route.query.id).then(async response => {
                                this.paymentConfirmed = response.data.success;
                                api.me();
                        });
                }
	}
}
</script>

<style scoped>
.btn{
	border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// src/views/Profile/CheckPayment.vue